import React, { useState } from 'react'
import PropTypes from 'prop-types';
import CustomModal  from './CustomModal';


const MessageModal = ({showModal, message, cancelHandler}) => {

        
    const handleCancel = () => {
        cancelHandler();    /* call parent's cancel handler */
    }


    return  (
        <CustomModal showCustomModal={showModal}>
            <div className="msg-modal-container">
                <div className="msg-modal-cancel-button" onClick={handleCancel}>X</div>
                <div className="msg-modal-text">{message}</div>
            </div>
        </CustomModal>
    )
}


MessageModal.propTypes = {
    showModal:  PropTypes.bool.isRequired,
    message:    PropTypes.string
}

MessageModal.defaultProps = {
    message:   "To replace this message, pass in the message prop"
}

export default MessageModal;








// WEBPACK FOOTER //
// ./src/components/modals/MessageModal.js